import { HeaderNavSetting } from '../interfaces/system/NavLinkConfig';
import { apiService } from './apiService';
import { SolutionTypeFilter } from '../constants/user-info/solutionType';

type GetUserNavLinksParams = {
  solution?: SolutionTypeFilter;
};

type GetUserNavLinksResponse = {
  headerSettings: HeaderNavSetting[];
};

type GetGoHighLevelAuthorizationLinkResponse = {
  redirectUrl: string;
};

export const systemService = {
  async getUserNavLinks(params?: GetUserNavLinksParams) {
    const resp = await apiService.get<GetUserNavLinksResponse>(
      'api/page-config/header/settings',
      { params },
    );

    return resp.data;
  },

  async getGoHighLevelAuthorizationLink() {
    const resp = await apiService.get<GetGoHighLevelAuthorizationLinkResponse>(
      'api/oauth/marketplace/authorization-link',
    );

    return resp.data;
  },
};
